module.exports = __webpack_public_path__ + "static/media/ilo_contact_.57d6ddb0.jpg";